module.exports = __webpack_public_path__ + "4223a92f83ae5fea639da8a0eaab70be.pdf";